<div class="internal-pages-body">
  <app-internal-header></app-internal-header>

  <!--SIGA section-->
  <div class="container-fluid w-1400 main-content">
      <div class="row justify-content-center">
        <div class="col-12 col-md-4 col-lg-3 mb-4 mb-md-0">
          <div class="siga-content">
            <app-navigation></app-navigation>
          </div>
        </div>

        <!--graph section-->
        <div class="col-12 col-md-7 col-lg-9">
          <div class="graph-section">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
  </div>
</div>
